'use client'

import { Close, Content, Overlay, Portal, Root, Trigger } from '@radix-ui/react-dialog'
import { type ReactElement } from 'react'

import { Icon } from '@/components/icons/Icon'
import { type FloatingBoxType, type FloatingToggleType } from '@/defs/floating'
import { getClickawayIgnoreProps } from '@/utils/clickawayUtil'
import { cn } from '@/utils/commonUtil'

import { FloatingBox } from '../FloatingBox/FloatingBox'
import { FloatingProvider } from '../FloatingProvider/FloatingProvider'

import styles from './FloatingModal.module.scss'

const ignoreScopesProps = getClickawayIgnoreProps('allScopes')

type Props = {
  isFirst?: boolean
  isTop?: boolean
  trigger?: ReactElement
} & FloatingBoxType &
  FloatingToggleType

export const FloatingModal = ({ isFirst, isOpen, isTop, setIsOpen, trigger, ...props }: Props) => (
  <Root onOpenChange={setIsOpen} open={isOpen}>
    {trigger && <Trigger asChild>{trigger}</Trigger>}
    <Portal>
      <Overlay className={cn(styles.blur, { isTop, styles })} />
      <Overlay className={cn(styles.mask, { isFirst, isTop, styles })} />
      <Overlay className={styles.container}>
        <FloatingProvider setIsOpen={setIsOpen}>
          <Content
            asChild
            onCloseAutoFocus={(e) => {
              const focused = document.activeElement
              if (focused && focused !== document.body) e.preventDefault()
            }}
          >
            <FloatingBox
              {...props}
              {...ignoreScopesProps}
              close={
                <Close aria-label='Close Modal' className={cn(styles.buttonClose, { isTop, styles })}>
                  <Icon name='xMark' />
                </Close>
              }
              overflowVisible
            />
          </Content>
        </FloatingProvider>
      </Overlay>
    </Portal>
  </Root>
)
